import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/fighters',
    name: 'fighters',
    component: () => import('@/views/FightersView.vue'),
  },
  {
    path: '/fighters/:id',
    name: 'fighter-detail',
    component: () => import('@/views/FighterDetailView.vue'),
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('@/views/EventsView.vue'),
  },
  {
    path: '/events/:id',
    name: 'event-detail',
    component: () => import('@/views/EventDetailView.vue'),
  },
  {
    path: '/rankings',
    name: 'rankings',
    component: () => import('@/views/RankingsView.vue'),
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/NewsView.vue'),
  },
  {
    path: '/compare',
    name: 'compare',
    component: () => import('@/views/CompareView.vue'),
  },
  {
    path: '/pickem',
    name: 'pickem',
    component: () => import('@/views/PickemView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    // Restore saved position on back/forward navigation
    if (savedPosition) {
      return savedPosition
    }
    // Scroll to hash anchor if present
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    // Scroll to top on new navigation
    return { top: 0 }
  },
})

// Focus management for accessibility (WCAG 2.4.3 Focus Order)
// Move focus to main content on navigation to help keyboard users maintain orientation
router.afterEach(() => {
  // Use requestAnimationFrame to ensure DOM has updated after navigation
  requestAnimationFrame(() => {
    const mainContent = document.getElementById('main-content')
    if (mainContent) {
      // Focus the main content element (must have tabindex="-1" to receive focus)
      mainContent.focus({ preventScroll: true })
    }
  })
})

export default router
